/**
 * hub.coranchers.com API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface PermissionRequestModel { 
    permissionId?: number;
    canView?: number;
    canCreate?: number;
    canEdit?: number;
    canDelete?: number;
    canPrint?: number;
    canEmail?: number;
    canOther?: number;
}

